import kssStateGenerator from './modules/kssStateGenerator'

const kss = {}

kss.stateGenerator = kssStateGenerator()

export { kss }
